import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { UserType } from "@/types/user";

const Logo = () => {
  const { user } = useAuth();
  const isDealer = user?.type === UserType.Dealer;

  return (
    <Link to="/" className="flex items-center">
      <span
        className={`font-bold text-2xl sm:text-xl md:text-xl tracking-tight ${
          isDealer && "text-accent"
        }`}
      >
        {isDealer ? "BEA" : "BILENIA"}
      </span>
    </Link>
  );
};

export default Logo;
